/* eslint perfectionist/sort-objects: 0 */
// This is divided by 10 for conversion to rem
export const SPACING_WEB = {
  xxs: 0.1,
  xs: 0.2,
  s: 0.4,
  m: 0.8,
  l: 1.6,
  xl: 2.4,
  xxl: 3.2,
  xxxxl: 4.8,
};

export const SPACING_MOBILE = {
  xxs: 1,
  xs: 3,
  s: 5,
  m: 10,
  l: 15,
  xl: 25,
  xxl: 30,
};

export const OPACITY_MOBILE = {
  transparent: 0,
  disabled: 0.5,
  full: 1,
  backdrop: 0.4,
};

export const ELEVATION = {
  default: 6,
};

export const BORDER_RADIUS = {
  badge: 100,
  default: 8,
  '2xl': 10,
  '3xl': 12,
};

export const FONT_FAMILY = {
  OpenSansBold: 'OpenSans-Bold',
  OpenSansBoldItalic: 'OpenSans-BoldItalic',
  OpenSansExtraBoldItalic: 'OpenSans-ExtraBoldItalic',
  OpenSansItalic: 'OpenSans-Italic',
  OpenSansLight: 'OpenSans-Light',
  OpenSansLightItalic: 'OpenSans-LightItalic',
  OpenSansMedium: 'OpenSans-Medium',
  OpenSansMediumItalic: 'OpenSans-MediumItalic',
  OpenSansRegular: 'OpenSans-Regular',
  OpenSansSemiBold: 'OpenSans-SemiBold',
  OpenSansSemiBoldItalic: 'OpenSans-SemiBoldItalic',
};
